module.exports = __webpack_public_path__ + "img/calendar.65788987.svg";